import { render } from "./PageSchema.vue?vue&type=template&id=18a22f40"
import script from "./PageSchema.vue?vue&type=script&lang=js"
export * from "./PageSchema.vue?vue&type=script&lang=js"

import "./PageSchema.vue?vue&type=style&index=0&id=18a22f40&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PageSchema.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18a22f40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18a22f40', __exports__)) {
    api.reload('18a22f40', __exports__)
  }
  
  module.hot.accept("./PageSchema.vue?vue&type=template&id=18a22f40", () => {
    api.rerender('18a22f40', render)
  })

}


export default __exports__